import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import FastAvatar from '../../molecules/FastAvatar'
import Icon from '../../atoms/Icon'

function SelectMenuOption ({ option, disabled, onClick, onDoubleClick, hideAvatar, icon, className }) {
  return (
    <div
      className={clsx('flex items-center gap-sm p-md menu-item-primary font-size-xs font-thin', className, {
        disabled: disabled,
        clickable: !disabled
      })}
      onClick={(e) => {
        if (!disabled) {
          return onClick(option, e)
        }
      }}
      onDoubleClick={(e) => {
        return onDoubleClick(option, e)
      }}
    >
      {hideAvatar ? null : (
        <FastAvatar
          avatarUrl={option.attributes?.avatarUrl}
          size='sm'
          abbreviation={option.attributes?.abbreviation}
        />
      )}
      {icon && hideAvatar ? (
        <Icon name={icon} customSize={24} />
      ) : null}
      <div>
        {option.label}
      </div>
    </div>
  )
}

SelectMenuOption.propTypes = {
  disabled: PropTypes.bool,
  option: PropTypes.shape({
    label: PropTypes.any,
    value: PropTypes.any,
    attributes: PropTypes.shape({
      avatarUrl: PropTypes.any,
      abbreviation: PropTypes.any
    }),
    icon: PropTypes.string
  }),
  onClick: PropTypes.func,
  onDoubleClick: PropTypes.func,
  hideAvatar: PropTypes.bool,
  icon: PropTypes.string,
  className: PropTypes.string
}

SelectMenuOption.defaultProps = {
  onClick: () => {}
}

export default SelectMenuOption
